export function normalize(value) {
  return String(value ?? '').trim();
}

export function isInviteReady({ email, role, mode = 'create', userId = null } = {}) {
  const normalizedEmail = normalize(email);
  const normalizedRole = normalize(role);

  if (!normalizedEmail || !normalizedRole) {
    return false;
  }

  const normalizedMode = normalize(mode).toLowerCase();
  if (normalizedMode === 'edit') {
    return Boolean(userId);
  }

  return true;
}
